export default __webpack_public_path__ + "static/media/xmasgift.1f17d372.svg";